import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { StoreProvider, useStore } from "@/context/StoreContext";
import { ThemeProvider, useTheme } from "@/context/ThemeContext";
import { useEffect } from "react";
import Login from "@/pages/Login";
import DefinirSenha from "@/pages/DefinirSenha";
import EsqueciSenha from "@/pages/EsqueciSenha";
import AppLayout from "@/components/AppLayout";
import Dashboard from "@/pages/Dashboard";
import ChamadosList from "@/pages/ChamadosList";
import ChamadoDetail from "@/pages/ChamadoDetail";
import NovoChamado from "@/pages/NovoChamado";
import Usuarios from "@/pages/Usuarios";
import Webhooks from "@/pages/Webhooks";
import Relatorios from "@/pages/Relatorios";
import Customizacao from "@/pages/Customizacao";

// Título da aba: "(abertos) {nome} - Zitec Tecnologia", atualizado a cada leitura de chamados
const DocumentTitle = () => {
  const { skin } = useTheme();
  const { user } = useAuth();
  const { tickets } = useStore();
  const abertos = user ? tickets.filter((t) => t.status === "aberto").length : 0;
  useEffect(() => {
    const name = skin.brandName.trim();
    const base = name ? `${name} - Zitec Tecnologia` : "Zitec Tecnologia";
    document.title = abertos ? `(${abertos}) ${base}` : base;
  }, [skin.brandName, abertos]);
  return null;
};

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <StoreProvider>
          <DocumentTitle />
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/definir-senha" element={<DefinirSenha />} />
              <Route path="/esqueci-senha" element={<EsqueciSenha />} />
              <Route path="/" element={<Protected><AppLayout /></Protected>}>
                <Route index element={<Dashboard />} />
                <Route path="chamados" element={<ChamadosList />} />
                <Route path="chamados/novo" element={<NovoChamado />} />
                <Route path="chamados/:id" element={<ChamadoDetail />} />
                <Route path="usuarios" element={<Usuarios />} />
                <Route path="webhooks" element={<Webhooks />} />
                <Route path="relatorios" element={<Relatorios />} />
                <Route path="customizacao" element={<Customizacao />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </StoreProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
